import { createSnackMessage } from 'src/components/common';
import { useGenericNotification } from 'src/hooks/common';

export const useNotification = () => {
  return useGenericNotification(createSnackMessage);
};
